"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var newsletterSignUpLanguages = function newsletterSignUpLanguages(_ref) {
  var _global$__appConfig__, _global$__appConfig__2, _global$__appConfig__3;
  var language = _ref.language;
  return (_global$__appConfig__ = global.__appConfig__) === null || _global$__appConfig__ === void 0 ? void 0 : (_global$__appConfig__2 = _global$__appConfig__.newsletterSignUpLanguages) === null || _global$__appConfig__2 === void 0 ? void 0 : (_global$__appConfig__3 = _global$__appConfig__2.split(",")) === null || _global$__appConfig__3 === void 0 ? void 0 : _global$__appConfig__3.includes(language);
};
var _default = newsletterSignUpLanguages;
exports["default"] = _default;